import * as actions from './actions';

const initialState = {
  available: true,
  crystals: [],
  questions: [],
  reading: null,
  readingEvaluated: false,
  leadCaptured: false,
  emailSending: false,
  emailSent: false,
  error: null,
  submitError: null,
  loading: false,
  initial: false,
};

export default function crystalsReducer(state = initialState, action) {
  switch (action.type) {
    // Availability
    case actions.FETCH_CRYSTAL_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_CRYSTAL_AVAILABILITY_SUCCESS:
      return { ...state, available: action.payload.available, loading: false, initial: true, error: null };

    case actions.FETCH_CRYSTAL_AVAILABILITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Questionnaire
    case actions.FETCH_CRYSTAL_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_CRYSTAL_QUESTIONNAIRE_SUCCESS:
      return { ...state, questions: action.payload.questions, loading: false, error: null };

    case actions.FETCH_CRYSTAL_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Submit
    case actions.SUBMIT_CRYSTAL_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, submitError: null, reading: null };

    case actions.SUBMIT_CRYSTAL_QUESTIONNAIRE_SUCCESS:
      return { ...state, reading: action.payload.reading, loading: false, submitError: null };

    case actions.SUBMIT_CRYSTAL_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, submitError: action.payload };

    // All crystals (catalog)
    case actions.FETCH_ALL_CRYSTALS_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_ALL_CRYSTALS_SUCCESS:
      return { ...state, crystals: action.payload.crystals, loading: false, error: null };

    case actions.FETCH_ALL_CRYSTALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Like
    case actions.SET_CRYSTAL_READING_LIKE_REQUEST:
      return { ...state };

    case actions.SET_CRYSTAL_READING_LIKE_SUCCESS:
      return { ...state, readingEvaluated: true };

    case actions.SET_CRYSTAL_READING_LIKE_FAILURE:
      return { ...state };

    // Lead capture
    case actions.CAPTURE_CRYSTAL_LEAD_REQUEST:
      return { ...state };

    case actions.CAPTURE_CRYSTAL_LEAD_SUCCESS:
      return { ...state, leadCaptured: true };

    case actions.CAPTURE_CRYSTAL_LEAD_FAILURE:
      return { ...state };

    // Send free reading by email
    case actions.SEND_CRYSTAL_READING_EMAIL_REQUEST:
      return { ...state, emailSending: true };

    case actions.SEND_CRYSTAL_READING_EMAIL_SUCCESS:
      return { ...state, emailSending: false, emailSent: true };

    case actions.SEND_CRYSTAL_READING_EMAIL_FAILURE:
      return { ...state, emailSending: false };

    // Reset
    case actions.RESET_CRYSTALS:
      return { ...initialState };

    default:
      return state;
  }
}
